




























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class BrowserControlsIcon extends Vue {
  @Prop({ default: '69' }) readonly width?: string;
  @Prop({ default: '15' }) readonly height?: string;
  @Prop({ default: 'currentColor' }) readonly color?: string;
}
